import React from "react";
import Footer from "./Footer";
import SEO from '../components/SEO.jsx';

export default function Apropos() {
  return (
    <>
   <SEO
     title="À propos"
     description="Découvrez CodeShop225, votre boutique de confiance pour l'achat de jeux vidéo digitaux et cartes cadeaux en Côte d'Ivoire."
     path="/A__propos"
   />
   <div className="container">
     <div className="min-h-screen bg-gray-50 py-12 px-6 flex justify-center">
      <div className="max-w-5xl bg-white shadow-xl rounded-2xl p-10">
        {/* Titre */}
        <h1 className="text-4xl font-bold text-gray-900 mb-6 text-center">
          À propos de <span className="text-indigo-600">CodeShop225</span>
        </h1>

        {/* Intro */}
        <p className="text-gray-600 leading-relaxed mb-8 text-lg text-center">
          CodeShop225 est votre plateforme fiable pour l’achat de{" "}
          <span className="font-semibold">jeux numériques</span>,{" "}
          <span className="font-semibold">cartes PSN</span> et{" "}
          <span className="font-semibold">cartes iTunes</span>, conçue pour vous
          offrir une expérience simple, rapide et sécurisée. Nous nous engageons
          à vous fournir vos codes et jeux dans un délai maximum de{" "}
          <span className="font-semibold">30 minutes</span>, afin que vous
          puissiez profiter immédiatement de vos achats.
        </p>

        {/* Pourquoi nous choisir */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Pourquoi choisir CodeShop225 ?
          </h2>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start gap-2">
              ✅ <span><strong>Sécurité garantie :</strong> Tous nos codes sont 100 % valides et vérifiés avant livraison.</span>
            </li>
            <li className="flex items-start gap-2">
              ⚡ <span><strong>Rapidité exceptionnelle :</strong> Recevez vos codes directement après votre paiement, sans attente inutile.</span>
            </li>
            <li className="flex items-start gap-2">
              💬 <span><strong>Support client réactif :</strong> Notre équipe est disponible pour répondre à vos questions et vous accompagner.</span>
            </li>
          </ul>
        </section>

        {/* Livraison */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Livraison et disponibilité
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Chaque achat est traité en temps réel, avec un délai de livraison
            maximum de <span className="font-semibold">30 minutes</span>. Nous
            garantissons que vos codes PSN ou iTunes fonctionnent parfaitement
            et sont prêts à être utilisés dès réception.
          </p>
        </section>

        {/* Légalité */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Limitation des jeux – légalité
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Il est important de noter que nous ne pouvons pas limiter ou
            bloquer l’accès à certains jeux, car cela serait illégal selon la
            législation de la Cour européenne de justice ainsi que l’article 99
            du décret législatif royal 1/1996. Tous les utilisateurs ont le
            droit d’accéder aux contenus achetés sans restrictions injustifiées.
          </p>
        </section>

        {/* Mission */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Notre mission
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Chez <span className="font-semibold">CodeShop225</span>, nous
            voulons rendre le monde du jeu numérique accessible, rapide et
            sécurisé pour tous. Que vous soyez joueur occasionnel ou gamer
            passionné, vous trouverez chez nous les codes qui correspondent à
            vos besoins, toujours avec la garantie de qualité et de fiabilité.
          </p>
        </section>

        {/* Conclusion */}
        <p className="text-gray-700 text-center text-lg font-medium mt-6">
          🎮 Rejoignez-nous dès aujourd’hui et découvrez la facilité d’acheter
          vos jeux et cartes numériques en toute confiance. Avec{" "}
          <span className="text-indigo-600 font-bold">CodeShop225</span>, le jeu
          commence dès que vous le souhaitez !
        </p>

        {/* Footer */}
        {/* <div className="mt-10 border-t pt-4 text-sm text-gray-500 text-center">
          &copy; {new Date().getFullYear()} CodeShop225 - Tous droits réservés.
        </div> */}
      </div>
    </div>
   </div>
      <Footer/>
    </>
  );
}